import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { PrivacyConsentDialogDirective } from '../privacy-consent-dialog.directive';

@Component({
  selector: 'ed-privacy-consent-icon-button',
  imports: [
    CommonModule,
    PrivacyConsentDialogDirective,
    MatIconButton,
    MatIcon,
    MatTooltip,
  ],
  templateUrl: './privacy-consent-icon-button.component.html',
  styleUrl: './privacy-consent-icon-button.component.scss',
  standalone: true,
})
export class PrivacyConsentIconButtonComponent {}
